module.exports = __webpack_public_path__ + "img/adress1.2ba24284.png";